module.exports = __webpack_public_path__ + "img/portobay-liberdade.4628b8d0.jpg";